import React, { FunctionComponent } from "react";
import robot1_img from "../../asserts/svg/robot_1.svg";
import robot2_img from "../../asserts/svg/robot_2.svg";
import "./style.scss";
import robot_point from "../../asserts/svg/robot_point.svg";

const GreetingBlock: FunctionComponent = () => {
    return <div className="GreetingBlock">
        <div className="content">
            <div className="prefix">T://</div>
            <div className="text">
                <div className="row">
                    Greetings, human!
                    <img className="robot" src={robot1_img} alt="robot" />
                </div>
                <div className="row">Don’t like logging hours?</div>
                <div className="row">
                    We neither.
                    <img className="robot" src={robot2_img} alt="robot2" />
                </div>

                <div className="row mt">So we hackathoned this intelligent</div>
                <div className="row">piece of software art to</div>
                <div className="row red cursor">
                    SAVE US ALL
                    <img className="robot point" src={robot_point} alt="robot_point" />
                </div>
            </div>
        </div>
    </div>
}

export default GreetingBlock;